import React, { useState } from 'react';
import { Tooltip, Button, Pagination } from 'antd';
import { Edit } from '@material-ui/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import PrizesFormModal from 'components/Dashboard/WorldCup/Prizes/PrizesFormModal';
import { Prizes } from 'core/worldCup/prizes/types';
import { Img } from 'react-image';
import { getImageLink } from 'utilities/common';
import { PAGE_SIZE_OPTIONS } from 'utilities/constants';

type PrizesTableType = {
  prizesData: Array<Prizes | null>;
  total: number;
  current: number;
  pageSize: number;
  onChangePage: (page: number, size: number) => void;
  setCurrent: (e: number) => void;
  setPageSize: (e: number) => void;
  campaignId?: number | null;
};

const PrizesTable: React.FC<PrizesTableType> = ({
  prizesData,
  total,
  current,
  pageSize,
  onChangePage,
  setCurrent,
  setPageSize,
  campaignId,
}) => {
  const [isShowDetailModal, setShowDetailModal] = useState(false);
  const [prizeInfo, setPrizeInfo] = useState<Prizes | null>(null);
  const intl = useIntl();

  const handleChangePage = (page: number, size: number) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage(page, size);
  };

  const handleShowSizeChange = (_c: number, s: number) => {
    handleChangePage(1, s);
  };

  const renderPrizesImage = (item: Prizes | null) => {
    if (item?.image) {
      return <Img src={getImageLink(item.image)} alt="prize" />;
    } else {
      return <div className="photo_name">{`${item?.name ? item.name.charAt(0) : ''}`}</div>;
    }
  };

  return (
    <div className="prizes_table_layout" id="prizes_table_layout">
      <div className="table_header">
        <div className="id">
          <FormattedMessage id="ID" />
        </div>
        <div className="prizes_photo" />
        <div className="prize_main">
          <FormattedMessage id="Prize" />
        </div>
        <div className="quantity">
          <FormattedMessage id="Prize quantity" />
        </div>
        <div className="visa">
          <FormattedMessage id="Requires VISA" />
        </div>
        <div className="actions">
          <FormattedMessage id="Actions" />
        </div>
      </div>
      <div>
        <div className="table_content" id="prizes_table_content">
          {Array.isArray(prizesData) &&
            prizesData.map((item, index) => (
              <div className={`table_item type_state_${item?.isActive}`} key={index} id={`prize_item_${item?.id}`}>
                <div className="id">
                  <p>{item?.id}</p>
                </div>
                <div className="prizes_photo">
                  <div className="photo_wrapper">{renderPrizesImage(item)}</div>
                </div>
                <div className="prize_main">
                  <p className="main_name">{item?.name}</p>
                  {item?.rewardType?.name && (
                    <p className="sub_info">{item.rewardType.name}</p>
                  )}
                  {item?.sponsor?.name && (
                    <p className="sub_info">{item.sponsor.name}</p>
                  )}
                </div>
                <div className="quantity">
                  <p>{item?.quantity}</p>
                </div>
                <div className="visa">
                  <span className={`visa_badge ${item?.hasAmericanVisa ? 'yes' : 'no'}`}>
                    {item?.hasAmericanVisa
                      ? intl.formatMessage({ id: 'Yes' })
                      : intl.formatMessage({ id: 'No' })}
                  </span>
                </div>
                <div className="actions">
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: 'Edit prize' })}
                    id="prize_edit_tooltip"
                  >
                    <Button
                      className="edit_btn"
                      onClick={() => {
                        setPrizeInfo(item);
                        setShowDetailModal(true);
                      }}
                      id="prize_edit_btn"
                    >
                      <Edit />
                    </Button>
                  </Tooltip>
                </div>
              </div>
            ))}
        </div>
        <div className="pagination_wrapper">
          <Pagination
            showSizeChanger
            defaultCurrent={1}
            defaultPageSize={10}
            current={current}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            total={total}
            onChange={handleChangePage}
            onShowSizeChange={handleShowSizeChange}
          />
          <div className="total">Resultados: {total}</div>
        </div>
      </div>
      <PrizesFormModal
        mode="modal"
        isOpenModal={isShowDetailModal}
        onCloseModal={() => setShowDetailModal(false)}
        onSaveSuccess={() => onChangePage(current, pageSize)}
        prize={prizeInfo}
        campaignId={campaignId}
      />
    </div>
  );
};

export default PrizesTable;
